<template>
  <div class="contract-page margin-top-20 " style="padding-bottom: 30px;">
    <template>
      <div class="vtb-list">
        <template v-for="(item,index) in vtbList">
          <div class="vtb-item" :class="{'vtb-item-active':vtbIndex==index}" @click="clickvtb(index)">
            {{ item.title }} <span v-if="index!=0">({{ getNum(item.id) }})</span>
          </div>
        </template>
      </div>
      <div class="padding-left-10 padding-right-10">
        <div class="tab-header">
          <div class="tab-header-item">联系方式信息</div>
          <div class="tab-header-item">职务标签</div>
        </div>

        <div class="tab-content" v-if="list">
          <div v-for="(item, index) in list" :key="index" class="box5">
            <div class="tab-content-item">
              <!-- <el-avatar shape="square" :size="34"> </el-avatar> -->
              <div class="contactItem" :class="'icon0'+item.contactType"></div>
              <div class="margin-left-15">
                <div class="flex aligin-center">
                  <el-tag class="margin-right-10" type="danger" v-if="item.recommend=='1'"
                      effect="dark" size="mini">推荐
                  </el-tag>
                  <span>{{ item.contactDetail }}</span>
                </div>
                <div class="margin-top-5">联系人：{{ item.contactPerson || "--" }},{{ item.contactPosition || "" }}
                </div>
              </div>
            </div>
            <div class="tab-content-item">
              <el-tag class="margin-right-10" v-if="item.contactPosition" effect="dark" size="small">
                {{ item.contactPosition || "" }}
              </el-tag>
              <span v-else> --</span>
            </div>
          </div>

          <div class="padding-bottom-40" v-if="!list.length">
            <nomore></nomore>
          </div>
        </div>
        <div class="padding-bottom-40" v-else>
          <nomore></nomore>
        </div>

        <div class="text-right" style="padding: 20px 0">
          <el-pagination background :page-size="pagesize" :hide-on-single-page="false" :page-sizes="pageSizes"
              layout="prev, pager, next,sizes" @size-change="handleSizeChange"
              @current-change="handleCurrentChange($event,0)" :current-page="currentPage" :total="totalnum">
          </el-pagination>
        </div>
      </div>
    </template>
  </div>

</template>

<script>
export default {
  props: {
    id: {
      type: [String, Number],
      default: ""
    }
  },
  data() {
    return {
      totalnum: 0,
      currentPage: 1,
      pagesize: 10,
      vtbIndex: 0,
      list: [],
      vtbList: [{
        title: "全部",
        id: 0
      }, {
        title: "手机",
        id: 1
      }, {
        title: "固话",
        id: 2
      }, {
        title: "邮箱",
        id: 3
      }, {
        title: "微信",
        id: 7
      }, {
        title: "QQ",
        id: 5
      }, {
        title: "传真",
        id: 4
      }, {
        title: "其他",
        id: 6
      }],
      contract_count: {},
      pageSizes: [10, 20, 30, 40, 50]
    }
  },
  methods: {
    getlist() {
      this.$https.post({
            api: this.$api.api.interfacenew.contract_list,
            type: "formData",
          }, {
            start: this.currentPage,
            page_size: this.pagesize,
            id: this.id,
            type: this.vtbList[this.vtbIndex].id
            // 示例：1 联系方式类型筛选：0:全部；1：手机；2：固话；3：邮箱；4：传真；5：QQ；6：其他；7：微信
          },
          (response) => {
            this.list = response.data;
            this.totalnum = response.count;
          },
          (error) => {
            // console.log(error);
          }
      );
    },
    getContract_count() {
      this.$https.post({
            api: this.$api.api.interfacenew.contract_count,
            type: "formData",
          }, {
            id: this.id,
          },
          (response) => {
            this.contract_count = response.data
            let num = 0
            for (let i in response.data) {
              num += response.data[i]
            }

          },
          (error) => {
            // console.log(error);

          }
      );
    },
    getNum(id) {
      return this.contract_count[`a${id}`] || 0
    },
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getlist();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pagesize = size
      this.getlist();
    },
    clickvtb(e) {
      this.vtbIndex = e
      this.handleCurrentChange(1)
    }, toout(href) {
      // console.log(href)
      if (!href) {
        return false;
      }
      window.open(href)
    },
  },
  created() {
    this.getlist()
    this.getContract_count();
  }
}
</script>

<style lang="scss" scoped>
@import '../detailcss.scss';

.contract-page {
  padding: 0px 30px;
}

.tab-header {
  display: flex;
  border-bottom: solid #EEE 1px;
  background-color: #FAFAFA;

  .tab-header-item {
    flex: 1;
    line-height: 60px;
    padding: 0px 15px;
    font-size: 14px;
  }
}

.tab-content-item {
  flex: 1;
  display: flex;
  align-items: center;
  height: 70px;
  padding: 15px;
}

.vtb-list {
  display: flex;
  align-items: center;
  padding-bottom: 10px;
  border-bottom: solid #EEE 1px;
  margin-bottom: 20px;

  .vtb-item {
    height: 34px;
    display: flex;
    align-items: center;
    padding: 0px 15px;
    border: solid #EEE 1px;
    margin-right: 15px;
    border-radius: 100px;
    cursor: pointer;
  }

  .vtb-item-active {
    color: #66B5FE;
    border-color: #66B5FE;
  }
}
</style>



// WEBPACK FOOTER //
// contract-page.vue?69d184d2